import useHomeProperties from "@/hooks/common/useHomeProperties";

export const useShopifyConst = () => {
	const { symbol, storefrontAccessToken, shopifyDomain, countryIsoCode, languageIsoCode, clientId, storeId, customerRedirectUrl, ecommercePlatform="null", addToCartSuccessfullyPrompt, addToCartButtonSoldOutNotice, checkOutButtonSoldOutNotice, modelnumberLocation='', plpContentSource, c4aOAuth2State } = useHomeProperties();
	return {
		storefrontAccessToken,
		domain: shopifyDomain,
		ApiVersion: "2025-07", // mx版本配合后台同步升级
		countryIsoCode,
		languageIsoCode,
		// currencyCode: 'USD',
		clientId,
		storeId,
		customerRedirectUrl,
		ecommercePlatform,
		addToCartSuccessfullyPrompt,
		addToCartButtonSoldOutNotice,
		checkOutButtonSoldOutNotice,
		modelnumberLocation, // 墨西哥站点需要这个字段判断是否等于sku,是的话通过产品id请求获取sku
		// clientId: 'shp_35cd6431\u002D1e61\u002D4189\u002Daa84\u002D74d29c329f75', // b2b 登录需要用到
		// storeId: '75112939828', // b2b 登录需要用到
		// customerRedirectUrl: 'https:\/\/cms\u002Dinner\u002Duat\u002Daem.midea.com\/content\/midea\u002Daem\/us.html?wcmmode=disabled', // b2b 登录需要用到
		// customerRedirectUrl: 'https://cms-sit-aem.midea.com/content/midea-aem/us.html?wcmmode=disabled'
		plpContentSource,
		symbol,
		c4aOAuth2State //判断是否是新C4A登录
	}
};

export const shopifyConst = useShopifyConst();
export const isEnableShopify = shopifyConst.ecommercePlatform === "shopify" ? true : false;
